import React from "react";
import { Container, Grid } from "@mui/material";
import homebordertext from "../../../assets/images/homebordertext.png";
import EastIcon from "@mui/icons-material/East";
import {
  HomeMain,
  HomeBGWrap,
  TextImageWrap,
  TextImage,
  Title,
  Details,
  StyledLink,
} from "./styles";
import { useSelector } from "react-redux";

const CustomerHome = () => {
  const { isAuthenticated = false, user = {} } = useSelector(
    (state) => state.auth
  );
  const isAdmin = user?.role === "admin";
  const isAgent = user?.role === "agent";
  const redirectTo = isAuthenticated
    ? isAdmin
      ? "/admin/customers"
      : "/delivery-home"
    : "/login";
  const hideButton = isAgent;

  return (
    <>
      <HomeMain>
        <Container maxWidth="lg">
          <TextImageWrap>
            {/* <TextImage src={homebordertext} alt="homebordertext" /> */}
          </TextImageWrap>
          <Title>Techify</Title>
        </Container>
        <HomeBGWrap>
          <Container maxWidth="lg">
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} lg={6}>
                <Details>
                  Pay for your orders with our Cash on Delivery or E-Payment
                  modes at your convenience. Our delivery will ensure that your
                  items are delivered right to your door steps. You can easily
                  track your orders until they are delivered.
                </Details>
                {!hideButton && (
                  <>
                    <StyledLink to={redirectTo}>
                      Get started <EastIcon />
                    </StyledLink>
                  </>
                )}
              </Grid>
            </Grid>
          </Container>
        </HomeBGWrap>
      </HomeMain>
    </>
  );
};

export default CustomerHome;
